import { RootState } from '@app/model';
import { selectWithError } from '@shared/lib';

export const selectFirestoreUsersData = ({ admin: { firestoreUsers } }: RootState) => firestoreUsers;
export const selectIsFirestoreUsersLoading = ({ admin: { isFirestoreUsersLoading } }: RootState) =>
  isFirestoreUsersLoading;
export const selectIsCreateUsersLoading = ({ admin: { isCreateUsersLoading } }: RootState) => isCreateUsersLoading;
export const selectFirestoreUsersDataWithError = selectWithError(selectFirestoreUsersData, 'Firestore Users');
